import { FC } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import history from './routers/history';
import Layout from './components/LayoutComponents';
import { store } from './redux/store';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'video-react/dist/video-react.css';

import './resources/_antd.less'; // redefinition AntDesign variables
import './styles/common.scss';
import './styles/global.scss';
import './styles/icon-config.scss';
import './styles/cookie.scss';
import './styles/icon.css';

const App: FC = () => (
  <BrowserRouter>
    <HelmetProvider>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Helmet titleTemplate="Clik Hub | %s" />
          <Layout />
        </ConnectedRouter>
      </Provider>
    </HelmetProvider>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById('bds-hub'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
